<template>
  <div class="flex max-w-fit items-center justify-center gap-2">
    <label class="switch">
      <input
        :disabled="disabled"
        type="checkbox"
        :checked="!!modelValue"
        @change="updateModelValue"
      />
      <span class="slider round" :class="bgColor"/>
    </label>
    <span v-if="label">{{ label }}</span>
  </div>
</template>

<script setup>
import {computed} from "vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: {
    type: [Boolean, Number],
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  dark: {
    type: Boolean,
    default: false,
  },
});

const updateModelValue = () => {
  emits("update:modelValue", !props.modelValue);
};

const bgColor = computed(() => {
  if (props.modelValue) return "";
  return props.dark ? "bg-[#575e66]" : "bg-slate-300";
});
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  max-width: 40px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.15s;
  transition: 0.15s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.15s;
  transition: 0.15s;
}

input:checked + .slider {
  background: linear-gradient(135deg, rgba(13, 180, 236, 1) 0%, rgba(145, 35, 206, 1) 100%);
}

input:focus + .slider {
  box-shadow: 0 0 1px #064f31;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 28px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
